/* OOPS in-place category filter
   Scoped to the OOPS sale page only. Activates only if it finds the OOPS
   submenu + a product grid whose cards carry data-category. On any other
   page these elements aren't present together, so this script no-ops.

   How it works:
   - Each product card root carries data-category="{product.type | handle}"
     (e.g. "oops-lighting"), matching the submenu link handles.
   - Clicking a submenu link shows only matching cards (no page load),
     updates the active state, the count, and the URL (?category=handle).
   - The "All" link is identified via the parent collection handle, so
     empty categories filter correctly (show nothing) rather than show all.
*/
(function () {
  function handleFromHref(href) {
    if (!href) return '';
    var path = href.split('?')[0].split('#')[0].replace(/\/+$/, '');
    return path.split('/').pop();
  }

  function init() {
    var config = document.getElementById('oops-filter-config');
    var grid = document.querySelector('.product-grid');
    var submenu =
      document.querySelector('.collection-submenu-sticky') ||
      document.querySelector('nav[aria-label$="Navigation Menu"]');

    // Required pieces must all be present, or do nothing.
    if (!config || !grid || !submenu) return;

    var parentHandle = config.getAttribute('data-parent-handle') || '';
    var links = Array.prototype.slice.call(submenu.querySelectorAll('a'));
    var gridChildren = Array.prototype.slice.call(grid.children);
    if (!links.length) return;

    var countEl = document.getElementById('productCount');
    var totalCards = gridChildren.filter(function (c) {
      return c.hasAttribute('data-category');
    }).length;

    function apply(handle, push) {
      var isAll = !handle || handle === parentHandle;
      var visible = 0;

      gridChildren.forEach(function (child) {
        var cat = child.getAttribute('data-category');
        var show = isAll || cat === handle;
        child.style.display = show ? '' : 'none';
        if (show && cat) visible++;
      });

      links.forEach(function (a) {
        var h = handleFromHref(a.getAttribute('href') || '');
        var linkIsAll = !h || h === parentHandle;
        var isActive = isAll ? linkIsAll : h === handle;
        a.classList.toggle('active', isActive);
      });

      if (countEl) {
        countEl.textContent =
          'Showing ' + visible + ' of ' + totalCards + ' products';
      }

      if (push) {
        var url = new URL(window.location.href);
        if (isAll) {
          url.searchParams.delete('category');
        } else {
          url.searchParams.set('category', handle);
        }
        history.pushState({ category: handle }, '', url.toString());
      }
    }

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        apply(handleFromHref(a.getAttribute('href') || ''), true);
      });
    });

    window.addEventListener('popstate', function () {
      var url = new URL(window.location.href);
      apply(url.searchParams.get('category') || '', false);
    });

    // Apply initial state from the URL (shareable / back-button safe).
    var initial = new URL(window.location.href).searchParams.get('category') || '';
    apply(initial, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
